<!-- Added by Amisha on 2026-08-12. -->
<!-- Reason: display activity-specific Share and Manage Access controls from inline activity rows. -->
<wm-modal-confirm
  class="text-right"
  [janusStyling]="true"
  [shareModalDesign]="true"
  janusModalWidth="600px"
  (opened)="getShareApplicationDetails()"
  (accepted)="shareApplication()"
  (canceled)="details = null"
  commandText="Share"
  [moduleId]="'shareActivity' + (activity?.id || '')"
  [showButtonText]="false"
  [showButton]="false"
  title="Share Activity"
  buttonClass="btn btn-sm"
  [closeOnAccept]="false"
  tooltip="Share access to this activity"
  [form]="shareForm"
  [showCommandButton]="showCommandButton"
  [cancelText]="cancelText"
  #shareActivityModal
>
  <div *ngIf="sharingStatus === SharingStatus.Loading">
    Loading Share Details...
  </div>

  <ng-container *ngIf="details">
    <h3>Share</h3>
    <div *ngIf="sharingStatus === SharingStatus.Shared">
      An email has been sent to {{ details.emailAddress }} with a link allowing
      access to this application.
    </div>
    <div *ngIf="sharingStatus === SharingStatus.Sharing">
      Sharing application with {{ details.emailAddress }}...
    </div>

    <ng-container *ngIf="sharingStatus === SharingStatus.Loaded">
      <ul ngbNav #shareNavs="ngbNav" class="nav-tabs permit-tabs">
        <li ngbNavItem>
          <a ngbNavLink>Share</a>
          <ng-template ngbNavContent>
            <form [formGroup]="shareForm">
              <!-- Added by Amisha on 2026-08-12. -->
              <!-- Reason: keep the Email field visually separated from the Share tabs. -->
              <div class="form-group share-email-field">
                <wm-common-textfield
                  [data]="{ label: 'Email', value: details.emailAddress }"
                  formControlName="emailAddress"
                  (valueChange)="details.emailAddress = $event"
                ></wm-common-textfield>
                <sub>Email address of the person who you are sharing access with</sub>
              </div>
            </form>

            <div class="label"><strong>Access</strong></div>
            <div class="form-group px-3">
              <wm-common-textfield
                [data]="activitySearchFieldConfig"
                [(ngModel)]="activitySearchQuery"
                (ngModelChange)="handleActivitiesSearchChange($event)"
              ></wm-common-textfield>
            </div>

            <div class="activity-access-list">
              <ul class="list-group">
                <li class="list-group-item border-bottom activity-access-row activity-access-heading">
                  <div>Activity</div>
                  <div>Access</div>
                </li>
                <li
                  class="list-group-item border-bottom activity-access-row"
                  *ngIf="details.currentActivity"
                >
                  <div>{{ details.currentActivity.activityName }}</div>
                  <div>
                    <select
                      class="form-control"
                      [(ngModel)]="details.currentActivity.permission"
                    >
                      <option value="2">None</option>
                      <option value="0">Read</option>
                      <option value="1" *ngIf="canEdit(details.currentActivity)">Edit</option>
                    </select>
                  </div>
                </li>

                <li class="list-group-item border-bottom"><i>Prior Activities</i></li>
                <li
                  class="list-group-item border-bottom activity-access-row"
                  *ngFor="let priorActivity of filteredPriorActivities"
                >
                  <div>{{ priorActivity.activityName }}</div>
                  <div>
                    <select class="form-control" [(ngModel)]="priorActivity.permission">
                      <option value="2">None</option>
                      <option value="0">Read</option>
                      <option value="1" *ngIf="canEdit(priorActivity)">Edit</option>
                    </select>
                  </div>
                </li>
                <li
                  class="list-group-item border-bottom"
                  *ngIf="filteredPriorActivities.length === 0"
                >
                  <i>No Prior Activities</i>
                </li>

                <li class="list-group-item border-bottom"><i>Future Activities</i></li>
                <li
                  class="list-group-item border-bottom activity-access-row"
                  *ngFor="let futureActivity of filteredFutureActivities"
                >
                  <div>{{ futureActivity.activityName }}</div>
                  <div>
                    <select class="form-control" [(ngModel)]="futureActivity.permission">
                      <option value="2">None</option>
                      <option value="0">Read</option>
                      <option value="1" *ngIf="canEdit(futureActivity)">Edit</option>
                    </select>
                  </div>
                </li>
                <li
                  class="list-group-item border-bottom"
                  *ngIf="filteredFutureActivities.length === 0"
                >
                  <i>No Future Activities</i>
                </li>
              </ul>
            </div>
          </ng-template>
        </li>

        <li ngbNavItem>
          <a ngbNavLink>Manage Access</a>
          <ng-template ngbNavContent>
            <div class="form-group mt-4" *ngIf="(details.shares || []).length === 0">
              <i>Application has not been shared yet.</i>
            </div>
            <table class="table" *ngIf="(details.shares || []).length > 0">
              <thead>
                <tr>
                  <th>Email Address</th>
                  <th>Shared On</th>
                  <th>Activity</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let share of details.shares">
                  <tr>
                    <td>{{ share.emailAddress }}</td>
                    <td>{{ share.sharedOn | date: 'MM/dd/yyyy hh:mm a' }}</td>
                    <td>{{ share.currentActivity?.activityName }}</td>
                    <td>
                      <a href="#" (click)="$event.preventDefault(); showActivities(share)" class="janus-anchor">
                        Details
                      </a>
                    </td>
                    <td>
                      <wm-modal-confirm
                        [janusStyling]="true"
                        [showButton]="true"
                        buttonText="Remove"
                        commandText="Remove Access"
                        [buttonStyle]="ButtonStyle.Link"
                        [moduleId]="share.id"
                        title="Remove Access"
                        [showButtonText]="true"
                        (accepted)="removeSharedAccess($event)"
                      >
                        <p>
                          Are you sure you want to remove access to this application for
                          "{{ share.emailAddress }}"?
                        </p>
                      </wm-modal-confirm>
                    </td>
                  </tr>
                  <tr *ngIf="share.showDetails">
                    <td colspan="5">
                      <table class="table">
                        <thead>
                          <tr><th>Activity</th><th>Permission</th></tr>
                        </thead>
                        <tbody>
                          <tr *ngIf="!share.activities"><td colspan="2"><i>Loading...</i></td></tr>
                          <tr *ngFor="let sharedActivity of share.activities || []">
                            <td>{{ sharedActivity.activityName }}</td>
                            <td>{{ sharedActivity.permission | sharePermissionStatus }}</td>
                          </tr>
                          <tr *ngIf="share.activities?.length === 0">
                            <td colspan="2"><i>No Activities Shared</i></td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </ng-template>
        </li>
      </ul>
      <div [ngbNavOutlet]="shareNavs"></div>
    </ng-container>
  </ng-container>
</wm-modal-confirm>
